import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchModal } from './components/SearchModal';
import * as Styled from './styles';
import { Search } from 'icons';
import { isMobile } from 'utils';

export const OmniSearch = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <Styled.Button onClick={() => setIsModalOpen(true)} type="secondary">
        <Styled.SearchButtonWrapper>
          <Styled.LeftWrapper>
            <Search />
            {!isMobile() && (
              <Styled.SearchText>{t('generic.search')}</Styled.SearchText>
            )}
          </Styled.LeftWrapper>
        </Styled.SearchButtonWrapper>
      </Styled.Button>
      {isModalOpen && (
        <SearchModal isModalOpen setIsModalOpen={setIsModalOpen} />
      )}
    </>
  );
};
